export default {"src":"/_next/static/media/box-withOut-content.4b4b1c99.svg","height":124,"width":141,"blurWidth":0,"blurHeight":0};